"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

exports.default = user;
exports.resetPostalCode = resetPostalCode;
exports.validatePostalCode = validatePostalCode;

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POSTAL_CODE_RESET = "ms/user/postal_code_reset";
var POSTAL_CODE_LOAD = "ms/user/postal_code_load";
var POSTAL_CODE_SUCCESS = "ms/user/postal_code_success";
var POSTAL_CODE_FAIL = "ms/user/postal_code_fail";

var initialState = {
  loading: false,
  loaded: false,
  error: null
};

var resetState = {
  stateList: null,
  zipcode: null,
  states: null,
  country: null,
  cities: null
};

function user() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case POSTAL_CODE_RESET:
      return (0, _extends3.default)({}, state, resetState);
    case POSTAL_CODE_LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true,
        loaded: false,
        error: null
      });

    case POSTAL_CODE_SUCCESS:
      return (0, _extends3.default)({}, state, action.result, {
        loading: false,
        loaded: true,
        error: null
      });

    case POSTAL_CODE_FAIL:
      return (0, _extends3.default)({}, state, resetState, {
        loading: false,
        loaded: false,
        error: action.error
      });

    default:
      return state;
  }
}

function resetPostalCode() {
  return function (dispatch) {
    return dispatch({
      type: POSTAL_CODE_RESET
    });
  };
}

function validatePostalCode(_ref) {
  var countryCode = _ref.countryCode,
      postalCode = _ref.postalCode;

  return function (dispatch, getState) {
    var _getState = getState(),
        zipcode = _getState.address.zipcode;

    if (zipcode === postalCode) return new _bluebird2.default(function (resolve) {
      return resolve(true);
    });

    return dispatch({
      types: [POSTAL_CODE_LOAD, POSTAL_CODE_SUCCESS, POSTAL_CODE_FAIL],
      promise: function promise(client) {
        return client.post("v1/payments/customer/addresslookup", {
          data: { countryCode: countryCode, postalCode: postalCode }
        });
      }
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/address.js
// module id = 226
// module chunks = 0